import accounting from "accounting";
import moment from "moment";
import { CurrentUserType } from "providers/types";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useCallback, useMemo } from "react";
import { shortLoanAmountNew } from "utils/helpers";

export function useCustomFormats() {
  const { user: usert } = useTenant();
  //TODO: type the actual context instead
  const user = usert as CurrentUserType | null;

  const currency =
    (user?.company?.company_configurations?.[0]?.custom_currency as Record<string, string>)
      ?.currency || "$";

  const customFormat = useMemo(
    () => user?.company?.company_configurations?.[0]?.field_controls as Record<string, string>,
    [user]
  );

  const dateFormat = useMemo(() => {
    return customFormat?.funding_date ? "DD/MM/YYYY" : "MM/DD/YYYY";
  }, [customFormat]);

  const dateTimeFormat = useMemo(() => {
    return customFormat?.funding_date ? "DD/MM/YYYY HH:mm" : "MM/DD/YYYY HH:mm";
  }, [customFormat]);

  const datePickerFormat = customFormat?.funding_date ? "dd-MM-yyyy" : "MM-dd-yyyy";

  const formatCurrency = useCallback(
    (value: string | number, format: "short" | "long" = "long"): string => {
      const nValue = Number(value);

      if (format === "long") {
        const longVal = accounting.formatMoney(value, {
          symbol: currency,
          precision: 2,
        });
        return longVal;
      }

      return shortLoanAmountNew(nValue, { currency });
    },
    [currency]
  );

  const formatDate = useCallback(
    (date: Date | string | null, emptyText = "Not Provided") => {
      if (!date) return emptyText;

      if (date instanceof Date) {
        return moment(date).format(dateFormat);
      }

      if (typeof date === "string") {
        if (date.includes("T")) {
          return moment(date).format(dateFormat);
        }
        return moment(date, "YYYY-MM-DD").format(dateFormat);
      }

      return emptyText;
    },
    [dateFormat]
  );

  const formatDateTime = useCallback(
    (date: Date | string | null, emptyText = "Not Provided") => {
      if (!date) return emptyText;

      if (date instanceof Date) {
        return moment(date).format(dateTimeFormat);
      }

      if (typeof date === "string") {
        if (date.includes("T")) {
          return moment(date).format(dateTimeFormat);
        }
        return moment(date, "YYYY-MM-DD").format(dateTimeFormat);
      }

      return emptyText;
    },
    [dateTimeFormat]
  );

  return {
    formatCurrency,
    formatDate,
    formatDateTime,
    currencySymbol: currency,
    dateFormat,
    datePickerFormat,
  };
}
